export default "__VITE_ASSET__DyMHFRTw__"